import { GraphQLSnippet } from '../../../types';
import { generateSlug } from '../../../utils';

export const getSnippetSlug = (snippet: GraphQLSnippet): string =>
  generateSlug(snippet.name, snippet.positionalParameters);
